import { memo, useCallback } from "react";
import { Button, Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExternalLinkAlt,
  faSignInAlt,
  faUserAlt,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";

import { logout } from "@/store/authSlice";
import { BASE_URL } from "../../core/http";
import {
  LABELER,
  INTERN,
  LOGIN,
  REGISTER,
  DASHBOARD,
  MANAGER,
  TASKS,
  ORDERS,
  VIDEOS,
  SUMMARY,
} from "@/constants/routs.constants";
import NavMenuItem from "./NavMenuItem";

const Header = () => {
  const { isAuth, user } = useSelector(({ auth }) => auth);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = useCallback(() => {
    const activeConfirm = window.confirm("Are you sure you want to log out?");
    if (activeConfirm === true) {
      dispatch(logout());
    }
  }, [dispatch]);

  const adminLink = `${BASE_URL}admin/`;
  const singInIcon = <FontAwesomeIcon icon={faSignInAlt} />;
  const userPlusIcon = <FontAwesomeIcon icon={faUserPlus} />;
  const externalLinkIcon = <FontAwesomeIcon icon={faExternalLinkAlt} />;
  const userIcon = <FontAwesomeIcon icon={faUserAlt} />;
  return (
    <div className="header">
      <Navbar collapseOnSelect expand="lg" variant="dark">
        <Container>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto" navbarScroll>
              {isAuth && (
                <>
                  {user?.is_staff && (
                    <>
                      <NavMenuItem to={DASHBOARD} title="Dashboard" />
                      <NavMenuItem to={VIDEOS} title="Videos" />
                      <NavMenuItem to={MANAGER} title="Manager" />
                    </>
                  )}
                  <NavMenuItem to={INTERN} title="Study" />
                  <NavMenuItem to={LABELER} title="Labeler" />
                  <NavMenuItem to={TASKS} title="Tasks" />
                  {user?.is_staff && (
                    <NavMenuItem to={ORDERS} title="Orders" />
                  )}
                  <NavMenuItem to={SUMMARY} title="Summary" />

                  {user?.is_staff && (
                    <NavMenuItem
                      to={adminLink}
                      target="_blank"
                      title="Admin"
                      icon={externalLinkIcon}
                    />
                  )}
                </>
              )}
            </Nav>

            <Nav className="ms-auto">
              {isAuth ? (
                <NavDropdown
                  title={
                    <div style={{ display: "inline-block" }}>
                      {userIcon} {user.username}
                    </div>
                  }
                  align="end"
                  id="collasible-nav-dropdown"
                >
                  <NavDropdown.Item
                    as="button"
                    href="#action/3.4"
                    onClick={handleLogout}
                  >
                    <FontAwesomeIcon icon={["fas", "sign-out-alt"]} /> Sign out
                  </NavDropdown.Item>
                </NavDropdown>
              ) : (
                <>
                  <Button
                    variant="outline-light"
                    className="header__auth"
                    onClick={() => navigate(LOGIN)}
                  >
                    {singInIcon} Sign in
                  </Button>
                  <Button
                    variant="outline-light"
                    className="header__auth"
                    onClick={() => navigate(REGISTER)}
                  >
                    {userPlusIcon} Register
                  </Button>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default memo(Header);
